import ProjectView from "../project-view"
import {ProjectViewAccess} from "../@const"
import {ViewType} from "../../../gd/const/views/view-type"
import {ViewTypeConfigs} from "../../../gd/const/views/view-type-config"

export class ProjectView_AccessControl {

    protected projectView : ProjectView

    constructor(projectView:ProjectView) {
        this.projectView = projectView
    }

    get isPrivateViewOwner():boolean {
        return this.projectView.access === ProjectViewAccess.PRIVATE && this.isOwner
    }

    get hasFullAccess():boolean {
        return this.projectView.projectViews.project.acl.hasFullAccess
    }

    get hasStandardAccess():boolean {
        return this.projectView.projectViews.project.acl.hasStandardAccess
    }

    get isOwner():boolean {
        return this.projectView.userId === gd.user.id
    }

    get isEditableView():boolean {
        const viewTypeConfig    = ViewTypeConfigs[this.projectView.systemType]!
        return !viewTypeConfig.isSingleton
    }

    get requiresUpgrade():boolean {

        switch (this.projectView.systemType) {

            case ViewType.PROJECT_EXPENSES:
                return !gd.company.license.projectView(this.projectView.systemType)

            case ViewType.PROJECT_GANTT:
                return !gd.company.license.projectView(this.projectView.systemType)

            case ViewType.PROJECT_WORKLOAD:
                return !gd.company.license.projectView(this.projectView.systemType)

        }

        return false
    }

    get isReadonly():boolean {

        switch (this.projectView.access) {

            case ProjectViewAccess.PRIVATE:
                // only owner can modify
                return !this.isOwner


            case ProjectViewAccess.PUBLIC:
            default:
                // u need project full access to modify views
                if (this.hasFullAccess) return false
                return true
        }

    }


    get canRename():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canCopyURL():boolean {
        return true
    }

    get canEditSource():boolean {
        return false
    }

    get canEditForm():boolean {
        return false
    }

    get canCreateNew():boolean {
        return this.isEditableView && this.hasFullAccess
    }

    get canDuplicate():boolean {
        return this.isEditableView && this.hasFullAccess
    }

    get canResetToDefault():boolean {
        const allowResetToDefault = ![
            ViewType.PROJECT_LIST,
            ViewType.PROJECT_DASHBOARD
        ].includes(this.projectView.systemType as ViewType)

        return allowResetToDefault && this.isEditableView && (this.isPrivateViewOwner || this.hasFullAccess)
    }

    get canDelete():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canUseTemplates():boolean {
        const viewTypeConfig    = ViewTypeConfigs[this.projectView.systemType]!
        return !!viewTypeConfig.hasTemplates
    }

    get canSaveAsTemplate():boolean {
        return this.canUseTemplates && this.isEditableView && this.isOwner
    }

    get canLoadTemplate():boolean {
        return this.canUseTemplates && (this.isPrivateViewOwner || this.hasStandardAccess)
    }

    get canEditPermissions():boolean {
        return this.isEditableView && /*!!this.projectView.userId &&*/ (this.isOwner || this.hasFullAccess)
    }

    get canSetPublicPermission():boolean {
        return this.isEditableView && this.hasFullAccess
    }

    get canSetAsToDefault():boolean {
        return this.projectView.access === ProjectViewAccess.PUBLIC
    }

    /*

        const viewTypeConfig    = ViewTypeConfigs[this.systemType]!
        const isEditableView    = !viewTypeConfig.isSingleton

        const canUseTemplates   = isEditableView && viewTypeConfig.hasTemplates

        const allowResetToDefault = ![
            ViewType.PROJECT_LIST,
            ViewType.PROJECT_DASHBOARD
        ].includes(this.systemType as ViewType)

        const isFullAccess          = this.project.acl.hasFullAccess
        const isStandardAccess      = this.project.acl.hasStandardAccess
        const isUser                = gd.ac.check.company.isUser(gd.companyId)
        const hasOwner              = !!this.userId
        const isViewOwner           = this.userId === gd.user.id
        const isPrivateViewOwner    = this.access === ProjectViewAccess.PRIVATE && isViewOwner
        const isPage                = this.systemType === ViewType.PROJECT_PAGE

        this.availableActions = {
            canRename               : isPrivateViewOwner || isFullAccess,
            canEditSource           : false,
            canCreateNew            : isEditableView && isFullAccess,
            canDuplicate            : isEditableView && isFullAccess && !isPage,
            canResetToDefault       : allowResetToDefault && isEditableView && (isPrivateViewOwner || isFullAccess) && !isPage,
            canDelete               : isPrivateViewOwner || isFullAccess,
            canSaveAsTemplate       : canUseTemplates && isUser && !isPage,
            canLoadTemplate         : canUseTemplates && (isPrivateViewOwner || isStandardAccess) && !isPage,
            canEditPermissions      : isEditableView && hasOwner && (isViewOwner || isFullAccess),
            canSetPublicPermission  : isEditableView && isFullAccess,
            canSetAsToDefault       : this.access === ProjectViewAccess.PUBLIC
        }


     */

}

